import { CircularProgress } from "@mui/material";
import Button from "components/UI/Button";
import FlexboxContainerComponent from "components/UI/FlexboxContainer";
import InputComponent from "components/UI/Input";
import { IProductAddonForm } from "data/Service";
import React from "react";
import styled from "styled-components";
import { Background } from "styles/themeColors";
import Icon from "view/Icon";

const CloseIcon = styled(Icon).attrs({ name: 'x', size: 20 })`
  color: #de5100;
  margin: 8px 12px;
`;


interface Props {
    productAddon: IProductAddonForm;
    setProductAddon: (value: IProductAddonForm) => void;
    onAdd: () => void;
    hasError: boolean;
    setHasError: (val: boolean) => void;
    isLoading?: boolean;
    onCancel: () => void;
}

const OrderAddonForm = ({ productAddon, setProductAddon, onAdd, hasError = false, setHasError, isLoading = false, onCancel }: Props) => {
    return (
        <FlexboxContainerComponent width="100%" flexDirection="row" alignItems="flex-start" gap="5px" margin="0px 0px 20px 0px">
            <CloseIcon onClick={onCancel} className="pointer" />
            <InputComponent
                id="sku"
                value={productAddon.sku}
                onChange={(e) => { setProductAddon({ ...productAddon, sku: e.target.value }); setHasError(false) }}
                placeholder="Add SKU of a published add-on"
                isInvalid={hasError}
                errorMessage="SKU not found"
            />
            <InputComponent
                id="quantity"
                value={productAddon.quantity || ''}
                onChange={(e) => setProductAddon({ ...productAddon, quantity: parseInt(e.target.value) })}
                placeholder="QTY"
                width="120px"
                maxLength="4"
            />
            <Button
                onClick={() => onAdd()}
                disabled={!productAddon.sku || !productAddon.quantity || isLoading}
                bgColor={Background.navy}
                borderColor={Background.navy}
                padding="0px 50px"
            >
                {isLoading ? <CircularProgress size="16px" style={{ color: Background.white }} /> : <>Add</>}
            </Button>
        </FlexboxContainerComponent>
    );
}

export default OrderAddonForm;